import { useSelector } from 'react-redux';
import { GreenroomState } from '../../../stores/types/types';
import { showAlert } from '../../general-components/alert-service';
import {
	ISO_ALERT_DESCRIPTIONS, ISO_ALERT_DURATIONS, ISO_ALERT_MESSAGES,
} from '../constants';

const useBroadcastAlerts = () => {
	const host = useSelector(
		(state: GreenroomState) => state.SessionReducer.host,
	);
	const debugLogIsoAlerts = useSelector(
		(state: GreenroomState) => state.DebugReducer.debugLogIsoAlerts,
	);

	// time in milliseconds
	const handleTimeAlerts = (broadcastTimeElapsed: number) => {
		// ISO alerts
		if (host && ISO_ALERT_MESSAGES[broadcastTimeElapsed]) {
			showAlert({
				message: ISO_ALERT_MESSAGES[broadcastTimeElapsed],
				description: ISO_ALERT_DESCRIPTIONS[broadcastTimeElapsed],
				duration: ISO_ALERT_DURATIONS[broadcastTimeElapsed],
				type: 'warning',
			});

			if (debugLogIsoAlerts) {
				console.log(`ISO Recording Alert - ${ISO_ALERT_MESSAGES[broadcastTimeElapsed]} @ ${new Date().toLocaleString()}`);
			}
		}
	};

	return {
		handleTimeAlerts,
	};
};

export default useBroadcastAlerts;
